import {Popover} from 'antd';
import React from 'react';

import {PopoverContent} from './popoverContent';
import './audienceStats.scss';

export const AudienceStats = ({
  stats,
  campaign,
  isAdmin,
  loading,
  potential,
  children,
  getCampaignAudienceStats,
  onStatsClick,
}: any) => {
  return (
    <Popover
      onOpenChange={visible => (visible ? getCampaignAudienceStats(campaign.id) : null)}
      trigger="click"
      content={
        <PopoverContent
          stats={stats}
          campaign={campaign}
          isAdmin={isAdmin}
          loading={loading}
          potential={potential}
          onStatsClick={onStatsClick}
        />
      }
    >
      <div>{children}</div>
    </Popover>
  );
};
